var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconPayIn64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1916_20650)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.1176 19.5618C28.1176 14.5587 24.0619 10.5029 19.0588 10.5029C14.0558 10.5029 10 14.5587 10 19.5618C10 24.5648 14.0558 28.6206 19.0588 28.6206C24.0619 28.6206 28.1176 24.5648 28.1176 19.5618Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.1176 45.4441C28.1176 40.441 24.0619 36.3853 19.0588 36.3853C14.0558 36.3853 10 40.441 10 45.4441C10 50.4471 14.0558 54.5029 19.0588 54.5029C24.0619 54.5029 28.1176 50.4471 28.1176 45.4441Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 19.5618C54 14.5587 49.9442 10.5029 44.9411 10.5029C39.9381 10.5029 35.8823 14.5587 35.8823 19.5618C35.8823 24.5648 39.9381 28.6206 44.9411 28.6206C49.9442 28.6206 54 24.5648 54 19.5618Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 45.4441C54 40.441 49.9442 36.3853 44.9411 36.3853C39.9381 36.3853 35.8823 40.441 35.8823 45.4441C35.8823 50.4471 39.9381 54.5029 44.9411 54.5029C49.9442 54.5029 54 50.4471 54 45.4441Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1916_20650"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0 0.50293)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconPayIn64);
export default __webpack_public_path__ + "static/media/pictogramBeaconPayIn64.a440447d2a29907f4cc0d0a5b8e0b6b2.svg";
export { ForwardRef as ReactComponent };